<div class="flex flex-1 items-top" *ngIf="!showCompanyInfo">
	<app-address
		class="flex-1"
		[address]="initialValue"
		[enableCountrySelect]="true"
		name="Search Company Name / Address"
		(onAddressUpdate)="setCompany($event)"
	></app-address>
</div>

<app-container type="dark" size="small" class="mt-5" [title]="label">
	<div *ngIf="showCompanyInfo">
		<form #myForm="ngForm" (ngSubmit)="_onSubmit(myForm.form)">
			<div class="flex flex-col">
				<app-input
					label="Company Name"
					[name]="labels.NAME"
					type="text"
					[(ngModel)]="_name"
					class="m-1"
				></app-input>
				<mat-label class="mt-3 font-bold"> Contact details</mat-label>
				<app-input
					label="Work phone"
					[name]="labels.PHONE_NUMBER"
					type="tel"
					[(ngModel)]="_phoneNumber"
					class="m-1"
				></app-input>
				<app-input
					label="Fax"
					[name]="labels.FAX_NUMBER"
					type="tel"
					[(ngModel)]="_fax"
					class="m-1"
				></app-input>
				<app-input
					label="Email"
					[name]="labels.EMAIL"
					type="email"
					[(ngModel)]="_email"
					class="m-1"
				></app-input>
				<app-address
					[address]="_address"
					[enableCountrySelect]="!disableCountrySelect"
					name="Address"
					(onAddressUpdate)="onAddressUpdate($event)"
				>
				</app-address>
			</div>
			<div class="flex justify-between mt-5">
				<app-button type="button" btn="secondary" size="small" mat-dialog-close
					>Cancel</app-button
				>
				<div *ngIf="this._id; else create">
					<app-button
						type="submit"
						size="small"
						[loading]="loading"
						[disabled]="myForm.pristine && !addressChanged"
						>Update</app-button
					>
				</div>
				<ng-template #create>
					<app-button
						type="submit"
						size="small"
						[loading]="loading"
						[disabled]="myForm.pristine"
						>Create</app-button
					>
				</ng-template>
			</div>
		</form>
	</div>
</app-container>
